module.exports = __webpack_public_path__ + "static/LockClosed-3676d607e7ded3afddcd12fbf1bed02c.png";